export const getUploadCount = state => state.archiveUpload.numUploaded;
export const getError = state => state.archiveUpload.error;
